import BaseSettingHandler from './BaseSettingHandler';
import HELPER from '@/app/utils/HELPER';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';

/**
 * ShFontStyle
 */
export class ShFontStyle extends BaseSettingHandler {
  /**
   * read
   * @param options options
   * @returns returns
   */
  read(options: { $atom: JQuery; atomModel: AtomModel; screenType: any; $activePanel: JQuery }) {
    if (!this.setting.targetSelector) {
      alert(`Thiếu targetSelector: ${this.setting.name}`);
    } else {
      const { $atom } = options;
      const style = options.atomModel.style;
      const $targetSelector = $atom.find(this.setting.targetSelector);
      let selector = this.setting.targetSelector;
      if (this.setting.targetSelectors && this.setting.targetSelectors.length) {
        selector = this.setting.targetSelectors[0];
      }

      // Italic
      let fontItalic = HELPER.getValueFromCSS($targetSelector, style, 'font-style', options.screenType, selector);
      if (fontItalic == '') {
        fontItalic = $atom.find(selector).css('font-style');
      }
      if (fontItalic != 'italic') {
        fontItalic = '';
      }

      // Bold
      let fontWeight = HELPER.getValueFromCSS($targetSelector, style, 'font-weight', options.screenType, selector);
      if (fontWeight == '') {
        fontWeight = $atom.find(selector).css('font-weight');
      }
      if (fontWeight != 'bold') {
        fontWeight = '';
      }

      // Underline
      let fontUnderline = HELPER.getValueFromCSS(
        $targetSelector,
        style,
        'text-decoration',
        options.screenType,
        selector,
      );
      if (fontUnderline == '') {
        fontUnderline = $atom.find(selector).css('text-decoration');
      }
      if (fontUnderline != 'underline') {
        fontUnderline = '';
      }

      const fontStyle = `${fontItalic},${fontWeight},${fontUnderline}`;
      options.$activePanel.find('#font-style').val(fontStyle).attr('value', fontStyle).trigger('value-change');
    }
  }

  /**
   * write
   * @param value value
   * @param options options
   * @returns returns
   */
  write(
    value: any,
    options: {
      $atom: JQuery;
      atomModel: AtomModel;
      screenType: any;
    },
  ) {
    let style = options.atomModel.style;
    let fontItalic = '';
    let fontWeight = '';
    let fontUnderline = '';

    const arrayFontStyle = HELPER.trim(value, ',').split(',');
    for (let v = 0; v < arrayFontStyle.length; v++) {
      switch (arrayFontStyle[v]) {
        case 'bold':
          fontWeight = 'bold';
          break;
        case 'italic':
          fontItalic = 'italic';
          break;
        case 'underline':
          fontUnderline = 'underline';
          break;
      }
    }
    const deOptions = [
      {
        key: 'font-weight',
        value: fontWeight,
      },
      {
        key: 'font-style',
        value: fontItalic,
      },
      {
        key: 'text-decoration',
        value: fontUnderline,
      },
    ];

    const targetSelector = this.setting.targetSelector as string;
    const $targetSelector = options.$atom.find(targetSelector);
    if (this.setting.targetSelectors && this.setting.targetSelectors.length) {
      this.setting.targetSelectors.forEach((selector) => {
        style = HELPER.designOptions2Style($targetSelector, options.screenType, style, deOptions, selector);
      });
    } else {
      style = HELPER.designOptions2Style($targetSelector, options.screenType, style, deOptions, targetSelector);
    }
    return {
      refreshType: 'css',
      style,
    };
  }
}
